import generateAccounts from './baseAction';

const {
  getAccounts,
} = generateAccounts('account', 'accounts');

export {
  getAccounts,
};
